import { render, staticRenderFns } from "./PriceWorkflowPricing.vue?vue&type=template&id=82612b50&scoped=true&"
import script from "./PriceWorkflowPricing.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowPricing.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowPricing.vue?vue&type=style&index=0&id=82612b50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82612b50",
  null
  
)

export default component.exports